<template>
  <div class="layout-center-wrap">
    <div class="page-tit__wrap type-center">
      <h1 class="page-tit__sub">신고자(민간 보안 전문가)</h1>
      <h2 class="page-tit">회원가입</h2>
    </div>
    <h3 class="section-title">개인 정보 입력</h3>
    <table class="board-write type-block--mobile">
      <caption>
        회원가입을 위한 신고자(민간 보안 전문가) 정보 입력 표
      </caption>
      <tbody>
        <tr>
          <th scope="row">
            아이디
            <span class="svg_icon icon_must" aria-hidden="true"></span
            ><span class="sr-only">필수입력</span>
          </th>
          <td>
            <div class="layout-flex-row">
              <label for="id" class="sr-only"
                >아이디(6~20자 대/소문자 입력)</label
              >
              <input
                type="text"
                id="id"
                placeholder="아이디(6~20자 대/소문자 입력)"
                class="board-write__input"
                v-model="signupInfo.userId"
                v-on:change="isIdDuplicate = false"
              />
              <button
                type="button"
                class="btn btn--m"
                :class="isIdDuplicate ? 'btn--gray' : 'btn--medium_blue'"
                v-on:click="checkIdDuplicate"
              >
                중복확인
              </button>
            </div>
          </td>
        </tr>
        <tr>
          <th scope="row">
            비밀번호
            <span class="svg_icon icon_must" aria-hidden="true"></span
            ><span class="sr-only">필수입력</span>
          </th>
          <td>
            <label for="pw" class="sr-only">비밀번호 입력</label>
            <input
              type="password"
              id="pw"
              placeholder="비밀번호를 설정하십시오(숫자, 영문, 특수문자를 1개이상 8~20자리 이내로 입력)"
              v-model="signupInfo.userPw"
            />
          </td>
        </tr>
        <tr>
          <th scope="row">
            비밀번호 확인
            <span class="svg_icon icon_must" aria-hidden="true"></span
            ><span class="sr-only">필수입력</span>
          </th>
          <td>
            <label for="pw-new" class="sr-only">비밀번호 재입력</label>
            <input
              type="password"
              id="pw-new"
              v-model="checkPassword"
              placeholder="비밀번호 확인을 입력하십시오"
            />
          </td>
        </tr>
        <tr>
          <th scope="row">
            이름
            <span class="svg_icon icon_must" aria-hidden="true"></span
            ><span class="sr-only">필수입력</span>
          </th>
          <td>
            <label for="name" class="sr-only">이름 입력</label>
            <input
              type="text"
              id="name"
              class="board-write__input"
              value="본인 인증 시 사용된 이름으로 가입됩니다."
              disabled
            />
          </td>
        </tr>
        <tr>
          <th scope="row">
            영문 이름
            <span class="svg_icon icon_must" aria-hidden="true"></span
            ><span class="sr-only">필수입력</span>
          </th>
          <td>
            <label for="e-name" class="sr-only"
              >영문 이름 입력 : 영어만 가능</label
            >
            <input
              type="text"
              id="e-name"
              class="board-write__input"
              placeholder="영문이름을 입력하십시오"
              v-model="signupInfo.userEngName"
            />
          </td>
        </tr>
        <tr>
          <th scope="row">
            휴대전화 번호
            <span class="svg_icon icon_must" aria-hidden="true"></span
            ><span class="sr-only">필수입력</span>
          </th>
          <td>
            <label for="tel" class="sr-only">휴대전화 번호 입력</label>
            <input
              type="text"
              id="tel"
              class="board-write__input"
              value="본인 인증 시 사용된 휴대전화 번호로 가입됩니다."
              disabled
            />
          </td>
        </tr>
        <tr>
          <th scope="row">
            이메일
            <span class="svg_icon icon_must" aria-hidden="true"></span
            ><span class="sr-only">필수입력</span>
          </th>
          <td>
            <label for="email" class="sr-only">이메일 입력</label>
            <input
              type="text"
              id="email"
              class="board-write__input"
              placeholder="ex) example@google.com"
              v-model="signupInfo.email"
            />
          </td>
        </tr>
        <tr>
          <th scope="row">소속</th>
          <td>
            <label for="affiliation" class="sr-only">소속 입력</label>
            <input
              type="text"
              id="affiliation"
              class="board-write__input"
              placeholder="소속을 입력하십시오"
              v-model="signupInfo.userGroup"
            />
          </td>
        </tr>
      </tbody>
    </table>
    <fieldset class="section-pt">
      <legend class="section-title">
        개인정보 수집·이용 및 제3자 제공 위탁 동의
      </legend>
      <section class="agree__form">
        <article class="agree__all">
          <p>
            한국인터넷진흥원(KISA)은 「개인정보보호법」에 따라 사이버 보안
            취약점 정보 포털 서비스 제공을 위하여 아래와 같이 개인정보를
            수집·이용하며, 처리 위탁을 수행하고 있습니다.<br />
            내용을 확인하신 후 동의 여부를 선택하여 주시기 바랍니다
          </p>
          <label class="chk agree__chk"
            ><input type="checkbox" v-model="handleAgreeAll" />모두
            동의합니다.</label
          >
        </article>
        <article class="agree__container">
          <div class="agree__body terms__container">
            <p class="terms-tit">
              개인정보 수집·이용 동의
              <span class="sub">(필수)</span>
            </p>
            <p class="terms-content">
              - 수집·이용 목적 : 보안 취약점 신고 접수·처리 및 결과 안내, 인증서
              발급, 신고포상제 운영, 핵더챌린지 플랫폼 연동, 이용자 문의 응대<br />
            </p>
            - 수집·이용 항목 : 아이디, 비밀번호, 성명, 영문명, 휴대전화번호,
            이메일, 소속<br />
            - 보유·이용 기간 : 회원탈퇴 시 즉시 파기<br />
            - 동의 거부에 따른 불이익 : 동의를 거부할 수 있으나, 이 경우
            회원가입 및 서비스 이용이 제한됩니다.<br />
          </div>
          <div class="agree__footer">
            <p class="agree-label">개인정보 수집·이용에 동의합니다.</p>
            <div class="chk__wrap">
              <label class="chk chk--circle"
                ><input
                  type="radio"
                  name="agree1"
                  :value="false"
                  v-model="signupInfo.privacyAgree1"
                />동의안함</label
              >
              <label class="chk chk--circle"
                ><input
                  type="radio"
                  name="agree1"
                  :value="true"
                  v-model="signupInfo.privacyAgree1"
                />동의함</label
              >
            </div>
          </div>
        </article>
        <article class="agree__container">
          <div class="agree__body terms__container">
            <p class="terms-tit">
              개인정보 수집·이용 동의
              <span class="sub">(선택)</span>
            </p>
            <p class="terms-content">
              - 수집·이용 목적 : 신고포상제 명예의 전당 등록<br />
            </p>
            - 수집·이용 항목 : 성명, 닉네임, 웹사이트 주소<br />
            - 보유·이용 기간 : 회원탈퇴 후 6개월 간 보관<br />
            - 동의 거부에 따른 불이익 : 동의를 거부할 수 있으나, 이 경우 명예의
            전당 등록이 제한됩니다.  
          </div>
          <div class="agree__footer">
            <p class="agree-label">개인정보 수집·이용에 동의합니다.</p>
            <div class="chk__wrap">
              <label class="chk chk--circle"
                ><input
                  type="radio"
                  name="agree2"
                  :value="false"
                  v-model="signupInfo.privacyAgree2"
                  v-on:click="initHonorInfo"
                />동의안함</label
              >
              <label class="chk chk--circle"
                ><input
                  type="radio"
                  name="agree2"
                  :value="true"
                  v-model="signupInfo.privacyAgree2"
                />동의함</label
              >
            </div>
          </div>
          <div class="agree__footer" v-if="signupInfo.privacyAgree2">
            <table class="board-write type-block--mobile">
              <tbody>
                <tr>
                  <th scope="row" class="th--blue">
                    닉네임<span
                      class="svg_icon icon_must"
                      aria-hidden="true"
                    ></span
                    ><span class="sr-only">필수입력</span>
                  </th>
                  <td>
                    <div class="layout-flex-row">
                      <label for="nickname" class="sr-only">닉네임 입력</label>
                      <input
                        type="text"
                        id="nickname"
                        class="board-write__input"
                        v-on:change="isNickNameDuplicate = false"
                        v-model="signupInfo.userNickname"
                      />
                      <button
                        type="button"
                        class="btn btn--m"
                        :class="
                          isNickNameDuplicate ? 'btn--gray' : 'btn--medium_blue'
                        "
                        v-on:click="checkNickNameDuplicate"
                      >
                        중복확인
                      </button>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th scope="row" class="th--blue">웹사이트</th>
                  <td>
                    <label for="web" class="sr-only">웹사이트 입력</label>
                    <input
                      type="text"
                      id="web"
                      class="board-write__input"
                      v-model="signupInfo.userWebsite"
                      maxlength="200"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </article>
        <article class="agree__container">
          <div class="agree__body terms__container">
            <p class="terms-tit">
              개인정보 처리·위탁 동의
              <span class="sub">(필수)</span>
            </p>
            개인정보의 처리 위탁은 「개인정보보호법」제26조에 따라 아래와 같이
            수행됩니다.<br /><br />

            <div class="data-table__wrap">
              <table class="data-table">
                <caption class="sr-only">
                  제3자 제공 내역
                </caption>
                <colgroup>
                  <col style="width: 20%" />
                  <col style="width: 25%" />
                  <col />
                  <col style="width: 20%" />
                </colgroup>
                <thead>
                  <tr>
                    <th scope="col">위탁받는 자</th>
                    <th scope="col">위탁 업무</th>
                    <th scope="col">수집·이용 항목</th>
                    <th scope="col">수집·이용 기간</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>㈜아이넷캅</td>
                    <td>보안 취약점 신고 처리 지원, 신고포상제 운영</td>
                    <td>아이디, 성명, 휴대전화번호, 이메일</td>
                    <td>회원 탈퇴 또는 위탁계약 종료 시 즉시 파기</td>
                  </tr>
                  <tr>
                    <td>㈜루테스</td>
                    <td>사이버 보안 취약점 정보 포털 시스템 운영·유지보수</td>
                    <td>아이디, 성명, 휴대전화번호, 이메일</td>
                    <td>회원 탈퇴 또는 위탁계약 종료 시 즉시 파기</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <br />
            - 동의 거부 시 불이익 : 위탁 동의를 거부할 수 있으나, 이 경우
            회원가입 및 서비스 이용이 제한됩니다.  
          </div>
          <div class="agree__footer">
            <p class="agree-label">개인정보 처리·위탁에 동의합니다.</p>
            <div class="chk__wrap">
              <label class="chk chk--circle"
                ><input
                  type="radio"
                  name="agree3"
                  :value="false"
                  v-model="signupInfo.privacyAgree3"
                />동의안함</label
              >
              <label class="chk chk--circle"
                ><input
                  type="radio"
                  name="agree3"
                  :value="true"
                  v-model="signupInfo.privacyAgree3"
                />동의함</label
              >
            </div>
          </div>
        </article>
      </section>
      <div class="btn__wrap type-bottom-board">
        <button
          type="button"
          class="btn btn--l btn--blue btn--m_full"
          v-on:click="signup"
        >
          회원가입
        </button>
      </div>
    </fieldset>
  </div>
</template>

<script>
import { useRouter, useRoute } from "vue-router";
import { inject, ref, onMounted, watch } from "vue";
import { useStore } from "vuex";
import Auth from "./Auth.vue";
import dc from "@/component/DataChk.js";
import rsa from "@/component/RSAPublicKey.js";

export default {
  components: {
    Auth,
  },
  setup() {
    const axios = inject("axios");
    const lodash = inject("lodash");
    const router = useRouter();
    const route = useRoute();
    const store = useStore();
    const showLoading = () => store.dispatch("loading/show");
    const hideLoading = () => store.dispatch("loading/hide");

    // data 정의
    const defaultsignupInfo = () => ({
      refId: "",
      role: "REPORT",
      userId: "",
      userPw: "",
      userEngName: "",
      userNickname: "",
      userWebsite: "",
      email: "",
      userGroup: "",
      hasChild: false,
      hasHonorRegit: false,
      privacyAgree1: null,
      privacyAgree2: null,
      privacyAgree3: null,
    });
    const checkPassword = ref(null);
    const handleAgreeAll = ref(false);
    const isIdDuplicate = ref(false);
    const isNickNameDuplicate = ref(false);
    const signupInfo = ref(defaultsignupInfo());

    // methods 정의

    const checkIdDuplicate = () => {
      isIdDuplicate.value = false;
      if (!validateId()) {
        return;
      }

      showLoading();
      axios
        .post("/core/pu/member/id-vaild/get", {
          userId: signupInfo.value.userId,
        })
        .then((res) => {
          if (res.data.resType === "RES_OK") {
            alert("사용 가능한 아이디입니다.");
            isIdDuplicate.value = true;
          } else {
            alert(res.data.resMsg);
          }
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          hideLoading();
        });
    };

    const checkNickNameDuplicate = () => {
      isNickNameDuplicate.value = false;
      if (!dc.nullChk(signupInfo.value.userNickname)) {
        alert("닉네임을 입력하십시오.");
        return;
      }

      showLoading();

      axios
        .post("/core/pu/member/nickname-vaild/get", {
          userNickname: signupInfo.value.userNickname,
        })
        .then((res) => {
          if (res.data.resType === "RES_OK") {
            alert("사용 가능한 닉네임입니다.");
            isNickNameDuplicate.value = true;
          } else {
            alert(res.data.resMsg);
          }
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          hideLoading();
        });
    };

    const initHonorInfo = () => {
      signupInfo.value.userNickname = "";
      signupInfo.value.userWebsite = "";
      isNickNameDuplicate.value = false;
    };

    const validateId = () => {
      if (!dc.nullChk(signupInfo.value.userId)) {
        alert("아이디를 입력하십시오");
        return false;
      } else if (
        signupInfo.value.userId.length < 6 ||
        signupInfo.value.userId.length > 20
      ) {
        alert("아이디는 6~20자 사이로 올바르게 입력하십시오.");
        return false;
      }

      return true;
    };

    const validateSignupInfo = () => {
      if (
        !dc.nullChk(signupInfo.value.privacyAgree1) ||
        !signupInfo.value.privacyAgree1
      ) {
        alert("개인정보 수집·이용 동의 (필수) 항목에 동의하여 주십시오.");
        return false;
      }

      if (
        !dc.nullChk(signupInfo.value.privacyAgree3) ||
        !signupInfo.value.privacyAgree3
      ) {
        alert("개인정보 처리·위탁 동의 (필수) 항목에 동의하여 주십시오.");
        return false;
      }

      if (signupInfo.value.privacyAgree2) {
        if (!dc.nullChk(signupInfo.value.userNickname)) {
          alert(
            "개인정보 수집·이용 동의 (선택) 항목에 동의 시, 신고포상제 명예의 전당 등록을 위해 닉네임을 입력하여 주십시오."
          );
          return false;
        } else {
          if (!isNickNameDuplicate.value) {
            alert(
              "신고포상제 명예의 전당 등록을 위해 닉네임 중복체크를 진행해 주십시오."
            );
            return false;
          }
        }
      }

      if (!validateId()) {
        return false;
      }

      if (!isIdDuplicate.value) {
        alert("아이디 중복체크를 진행해 주십시오.");
        return false;
      }

      if (!dc.nullChk(signupInfo.value.userPw)) {
        alert("비밀번호를 입력하십시오");
        return false;
      } else if (!dc.passwordCheck(signupInfo.value.userPw)) {
        alert(
          `비밀번호는 숫자, 영문, 특수문자를 1개이상 8~20자리 이내로 입력하십시오.`
        );
        return false;
      } else if (signupInfo.value.userPw !== checkPassword.value) {
        alert("입력하신 비밀번호와 비밀번호 확인이 일치하지 않습니다.");
        return false;
      }

      if (!dc.nullChk(signupInfo.value.userEngName)) {
        alert("영문 이름을 입력하십시오");
        return false;
      }

      if (!dc.nullChk(signupInfo.value.email)) {
        alert("이메일을 입력하십시오");
        return false;
      } else if (!dc.emailValidChk(signupInfo.value.email)) {
        alert("이메일을 정확하게 입력하십시오.\n입력예시) korea@kisa.co.kr");
        return false;
      }

      return true;
    };

    const encrptySignupInfo = (info) => {
      info.userId = rsa.encryptData(info.userId);
      info.userPw = rsa.encryptData(info.userPw);
      info.email = rsa.encryptData(info.email);
    };

    const signup = () => {
      if (!validateSignupInfo()) {
        return;
      }

      showLoading();

      const info = lodash.cloneDeep(signupInfo.value);
      //암호화
      encrptySignupInfo(info);

      // 명예의 전당
      info.hasHonorRegit = signupInfo.value.privacyAgree2 ? true : false;
      axios
        .post("/core/pu/member/signup", info)
        .then((res) => {
          if (res.data.resType === "RES_OK") {
            axios.setErrorSession(1001);
          } else {
            axios.setErrorSession(1002, res.data?.resMsg);
          }
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          hideLoading();
        });
    };

    // watch 정의
    watch(handleAgreeAll, (newVal) => {
      const agree = newVal ? true : null;
      initHonorInfo();
      signupInfo.value.privacyAgree1 = agree;
      signupInfo.value.privacyAgree2 = agree;
      signupInfo.value.privacyAgree3 = agree;
    });

    // life cycle 정의
    onMounted(() => {
      if (!route.query.refId) {
        router.push("/");
        return;
      }
      signupInfo.value.refId = route.query.refId;
      // 만 14세 미만 여부
      signupInfo.value.hasChild = route.query.hasChild;

      rsa.getPublicKey();
    });

    // html에서 사용될 데이터 정의
    return {
      signupInfo,
      checkPassword,
      handleAgreeAll,
      isIdDuplicate,
      isNickNameDuplicate,
      checkIdDuplicate,
      checkNickNameDuplicate,
      initHonorInfo,
      signup,
    };
  },
};
</script>